import api from "./api";

export interface Subscriber {
  _id: string;
  email: string;
  status: "active" | "unsubscribed";
  subscribedAt: string;
}

export const subscriberService = {
  subscribe: async (email: string) => {
    const response = await api.post("/subscribers/subscribe", { email });
    return response;
  },

  unsubscribe: async (email: string) => {
    const response = await api.post("/subscribers/unsubscribe", { email });
    return response;
  },

  getAllSubscribers: async () => {
    const response = await api.get("/subscribers");
    return response;
  },

  deleteSubscriber: async (email: string) => {
    const response = await api.delete(`/subscribers/${email}`);
    return response;
  },
};
